import { Component, HostBinding, Input } from "@angular/core";

@Component({
  selector: "fuse-nav-vertical-item",
  templateUrl: "./nav-vertical-item.component.html",
  styleUrls: ["./nav-vertical-item.component.scss"],
})
export class FuseNavVerticalItemComponent {
  @HostBinding("class") classes = "nav-item";
  @Input() item: any;
}



// WEBPACK FOOTER //
// ./src/@fuse/components/navigation/vertical/nav-item/nav-vertical-item.component.ts